document.addEventListener('DOMContentLoaded', function() {
  // Function to sync Rebuy cart with Shopify cart
  function syncRebuyCartWithShopify(rebuyCart) {
    if (!rebuyCart) return;
    
    console.log('Syncing Rebuy cart count:', rebuyCart.item_count);
    
    // Trigger the theme's cart changed event with the Rebuy cart data
    // This will cause the theme to refresh the cart icon
    $(document).trigger('theme:cartchanged', { cart: rebuyCart });
  }
  
  // Handle Rebuy cart button clicks
  function setupCartClickHandlers() {
    // Prevent default cart link behavior and open Rebuy cart instead
    const cartLinks = document.querySelectorAll('.cart-link');
    cartLinks.forEach(link => {
      link.addEventListener('click', function(evt) {
        evt.preventDefault();
        console.log("Cart clicked, opening Rebuy SmartCart");
        if (window.Rebuy && window.Rebuy.SmartCart) {
          Rebuy.SmartCart.show();
        }
      });
    });
  }
  
  // Listen for all relevant Rebuy cart events
  const rebuyEvents = [
    'rebuy:smartcart.initialized',
    'rebuy:smartcart.line-item-added',
    'rebuy:smartcart.line-item-removed',
    'rebuy:smartcart.line-item-increase',
    'rebuy:smartcart.line-item-decrease',
    'rebuy:smartcart.cleared',
    'rebuy:cart.change'
  ];
  
  rebuyEvents.forEach(eventName => {
    document.addEventListener(eventName, function(event) {
      console.log('Rebuy event:', eventName);
      
      // Extract cart data from the event
      const cart = event.detail && event.detail.smartcart ? 
                  event.detail.smartcart.cart : 
                  (event.detail && event.detail.cart ? event.detail.cart : null);
      
      if (cart) {
        syncRebuyCartWithShopify(cart);
      } else {
        // If no cart in event, get latest cart data
        if (window.Rebuy && window.Rebuy.SmartCart) {
          Rebuy.SmartCart.get(function(cart) {
            if (cart) {
              syncRebuyCartWithShopify(cart);
            }
          });
        }
      }
    });
  });
  
  // Handle cart open/close classes
  document.addEventListener('rebuy:smartcart.show', () => {
    document.documentElement.classList.add('smartcart-open');
    document.body.classList.add('smartcart-open');
  });
  
  document.addEventListener('rebuy:smartcart.hide', () => {
    document.documentElement.classList.remove('smartcart-open');
    document.body.classList.remove('smartcart-open');
  });
  
  // Initialize integration with Rebuy
  function initializeRebuyIntegration() {
    // Set up cart click handlers
    setupCartClickHandlers();
    
    // Initial sync with Rebuy cart
    if (window.Rebuy && window.Rebuy.SmartCart) {
      Rebuy.SmartCart.get(function(cart) {
        if (cart) {
          syncRebuyCartWithShopify(cart);
        }
      });
    }
  }
  
  // Try to initialize immediately if Rebuy is already loaded
  if (window.Rebuy) {
    initializeRebuyIntegration();
  } else {
    // Wait for Rebuy to load
    document.addEventListener('rebuy:smartcart.ready', function() {
      console.log('Rebuy SmartCart is ready');
      initializeRebuyIntegration();
    });
    
    // Fallback initialization after a delay
    setTimeout(function() {
      if (window.Rebuy) {
        console.log('Initializing Rebuy integration after timeout');
        initializeRebuyIntegration();
      }
    }, 2000);
  }
});